export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 90,
    slots: {
      default: 'opt'
    }
  },
  {
    title: that.$l('table_label_changeVersion') || '变更版本号',
    field: 'changeOrderNo',
    minWidth: 170,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_order_no') || '订单编号',
    field: 'orderNo',
    minWidth: 150,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_oldOrderAmount') || '原订单成本总价',
    field: 'oldOrderAmount',
    minWidth: 150,
    headerAlign: 'center',
    align: 'right',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'oldOrderAmountInfo' }
  },
  {
    title: that.$l('table_label_newOrderAmount') || '变更后订单成本总价',
    field: 'newOrderAmount',
    minWidth: 150,
    headerAlign: 'center',
    align: 'right',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'newOrderAmountInfo' }
  },
  {
    title: that.$l('table_label_oldOrderSalesAmount') || '原订单销售总价',
    field: 'oldOrderSalesAmount',
    minWidth: 150,
    headerAlign: 'center',
    align: 'right',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'oldOrderSalesAmountInfo' }
  },
  {
    title: that.$l('table_label_newOrderSalesAmount') || '变更后订单销售总价',
    field: 'newOrderSalesAmount',
    minWidth: 150,
    headerAlign: 'center',
    align: 'right',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'newOrderSalesAmountInfo' }
  },
  {
    title: that.$l('table_label_changeContent') || '本次变更内容',
    field: 'changeContent',
    minWidth: 300,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_changeOrderStatus') || '订单变更状态',
    field: 'changeOrderStatus',
    width: 80,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      default: 'status'
    }
  },
  {
    title: that.$l('INDEX.table_label_created_by') || '创建人',
    field: 'createByName',
    headerAlign: 'center',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_created_date') || '创建时间',
    field: 'createTime',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    field: 'modifyByName',
    headerAlign: 'center',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_modification_date') || '修改时间',
    field: 'modifyTime',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_submit_by') || '提交人',
    field: 'submitByName',
    headerAlign: 'center',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_submit_time') || '提交时间',
    field: 'submitTime',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_reviewer_by_name') || '审核人',
    field: 'reviewByName',
    headerAlign: 'center',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_reviewer_by_time') || '审核时间',
    field: 'reviewTime',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true
  }
]
